import { accountRoutes } from '../../constants/routes';
import { NavbarLink } from './NavbarLink';
import { useTranslation } from 'react-i18next';
import { useCabinetMenuLinks } from '../../hooks/auth/cabinet/useCabinetMenuLinks';

export const MobileNavItemsList = ({ isAuthenticated, onClose }) => {
    const { t } = useTranslation();
    const links = useCabinetMenuLinks();

    return isAuthenticated ? (
        <div style={{ marginBottom: '2rem', display: 'grid' }}>
            <div
                style={{
                    marginTop: '6rem',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    fontSize: ' 16px',
                    display: 'flex',
                }}
            >
                <NavbarLink
                    className="nav__item url"
                    to={accountRoutes.CABINET}
                    isMobile
                    text={t('titleCabinet')}
                    onClose={onClose}
                />
            </div>
            {links.map((item) => (
                <NavbarLink
                    key={item.name}
                    to={item.to}
                    text={item.name}
                    icon={item.icon}
                    isMobile
                    onClose={onClose}
                />
            ))}
        </div>
    ) : null;
};
